const logs = [
  {
    id: '3e867111-4c89-4369-afbf-630ca2bd5228',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: null,
    action_type: 'BIKE_LOCKED',
    description: 'eSkoot-Test - [1011020288] locked successfully',
    success: true,
    parent_log_id: null,
    location_coord: '23.781242,90.4211609',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:36:17',
    trip: null,
    extra_data: {
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'L',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.781242,90.4211609',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },

  // has child
  {
    id: 'b8c330ec-f3ed-406d-86d6-4af04c85af05',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_FORCE_TRIP_COMPLETED',
    description: 'Forced complete trip',
    success: true,
    parent_log_id: 'dd16ba94-2183-481d-b771-8704994701f7',
    location_coord: '23.781242,90.4211609',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:36:17',
    trip: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
    extra_data: {
      trip_data: {
        id: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
        status: 'C',
        discount: 0,
        net_cost: 8,
        short_id: 'VgrZDPV',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: true,
        trip_duration: '2 min',
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 0,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1979,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'F',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'L',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.781242,90.4211609',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.dashboard.views_api',
    request_trace: {
      id: '3a6425c3-b566-4216-a779-087decb09c72',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-api.otoride.co:8083',
      path: '/dashboard/trips/717732c4-2fca-4c18-a32b-c4a2b1865cf0/complete/',
      is_secure: false,
      is_ajax: false,
      user_agent:
        'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.61 Safari/537.36',
      request_body:
        'b\'------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="trigger_lock"\\r\\n\\r\\ntrue\\r\\n------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="trigger_payment"\\r\\n\\r\\ntrue\\r\\n------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="riding_time_min"\\r\\n\\r\\n2\\r\\n------WebKit ...',
      response_code: 200,
      response:
        'b\'{"detail":"Trip force completed","trip":{"id":"717732c4-2fca-4c18-a32b-c4a2b1865cf0","pick_up_location":"Evan & Arif, Rd No 6, Dhaka 1212, Bangladesh","drop_off_location":"Evan & Arif, Rd No 6, Dhaka 1212, Bangladesh","pick_up_time":"2021-10-04 07:33:31","drop_off_time":"2021-10-04 07:35:31","user":{"id":"cfd16c78-aefa-4715-a7cb-f3337b160f6f","full_name":"Reduanul Islam","role_name":"Owner","profile_pic":"https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=ZKUOvEx67DqYkrtRRq6cFqqoPmQ%3D&Expires=1633336576","phone_number":"+8801757262754","email":"info.riduan@gmail.com"},"bike":{"id":"95092052-d0de-48fe-9eda-a7f69b7f5d91","bike_short_id":"omWlZNL","qr_code":"1011020288","bike_category":"P","current_loc_coord":"23.781242,90.4211609"},"trip_duration":"2 min","reservation_duration":null,"subscription":null,"applied_promo":null,"trip_points":[{"id":"c68bc32e-9863-4e5f-b376-e84df2bdc925","title":"Completed Trip","point":1,"reduce_to_zero":false,"organization":"829a48bf-3cde-4d2f-a00a-7ee97e55c6ba"}],"rating":"--","total_cost":8.75,"invoice":{"id":"a27b6a1a-5495-45ed-b72c-7488d7a86eef","title":"Unlock, Trip","date":"2021-10-04 07:33:31","amount":8.75,"currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"settled_amount":8.75,"settled_currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"amount_is_converted":false,"discount":0.0,"is_refunded":false,"status":"C","dispute_status":"","dispute_reason":"","dispute_reference":"","is_source_refundable":false,"refund_status":"","refund_failure_reason":"","refund_reference":""},"cost":6.0,"parking_pic":null,"trip_report":{"id":"7539ef5f-f0b6-436f-a9e0-44f48538db64","report_date":"2021-10-04 07:35:07","report_categories":"Damaged Vehicle","description":"test report on vehicle","admin_remarks":null,"status":"ATTENTION_REQUIRED","vehicle_parts":["BATTERY","LIGHTS","NOISE","SLOW","THROTTLE"],"report_images":[{"id":"d6681e12-cef8-4810-a117-c13ebfd3cfb0","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/d6681e12-cef8-4810-a117-c13ebfd3cfb0_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=N0LNRi4Hk4PzA2464UxMpsBlUxc%3D&Expires=1633336576"},{"id":"935a2cb6-5f5c-4f6a-ad75-8e4afe5d0cb1","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/935a2cb6-5f5c-4f6a-ad75-8e4afe5d0cb1_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=bGEyD4gogyKKbdc0J3mVyNrncbM%3D&Expires=1633336576"},{"id":"93fc9309-ce12-4626-b5b8-bf077848391b","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/93fc9309-ce12-4626-b5b8-bf077848391b_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=%2BKFgFyN%2FcHrQmBrEIupVNXmLO%2F0%3D&Expires=1633336576"}],"created_at":"2021-10-04 07:35:07","updated_at":"2021-10-04 07:35:07"},"on_ride_trip_path":[],"currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"created_at":"2021-10-04 07:33:31","updated_at":"2021-10-04 07:36:16","trip_short_id":"VgrZDPV","src_coord":"23.7812104,90.4211778","dest_coord":"23.781242, 90.4211609","reservation_start_time":null,"reservation_end_time":null,"reason_desc":"No reason provided","reserve_task_id":null,"start_power_level":"73.000","end_power_level":"73.000","status":"C","status_forced":true,"status_forced_by_system":false,"distance":"97.000","pause_cost":"0.000","reservation_charge":"0.000","unlock_charge":"1.000","discount":"0.00","rate_per_minute":"3.00","pause_rate_per_minute":"3.00","calories":"0.00","traversed_path":[],"is_paused":false,"tax_amount":"1.75","max_billing_adjusted_amount":"0.00"}}\'',
    },
  },

  {
    id: 'dd16ba94-2183-481d-b771-8704994701f7',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_TRIP_COMPLETED',
    description:
      "eSkoot-Test - [1011020288]'s trip [VgrZDPV] is completed | (Total Cost \u09f38.75)",
    success: true,
    parent_log_id: 'dd16ba94-2183-481d-b771-8704994701f7',
    location_coord: '23.781242,90.4211609',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:36:16',
    trip: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
    extra_data: {
      trip_data: {
        id: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
        status: 'C',
        discount: 0,
        net_cost: 8,
        short_id: 'VgrZDPV',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: true,
        trip_duration: '2 min',
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 0,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1979,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'F',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'L',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.781242,90.4211609',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: '3a6425c3-b566-4216-a779-087decb09c72',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-api.otoride.co:8083',
      path: '/dashboard/trips/717732c4-2fca-4c18-a32b-c4a2b1865cf0/complete/',
      is_secure: false,
      is_ajax: false,
      user_agent:
        'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.61 Safari/537.36',
      request_body:
        'b\'------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="trigger_lock"\\r\\n\\r\\ntrue\\r\\n------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="trigger_payment"\\r\\n\\r\\ntrue\\r\\n------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="riding_time_min"\\r\\n\\r\\n2\\r\\n------WebKit ...',
      response_code: 200,
      response:
        'b\'{"detail":"Trip force completed","trip":{"id":"717732c4-2fca-4c18-a32b-c4a2b1865cf0","pick_up_location":"Evan & Arif, Rd No 6, Dhaka 1212, Bangladesh","drop_off_location":"Evan & Arif, Rd No 6, Dhaka 1212, Bangladesh","pick_up_time":"2021-10-04 07:33:31","drop_off_time":"2021-10-04 07:35:31","user":{"id":"cfd16c78-aefa-4715-a7cb-f3337b160f6f","full_name":"Reduanul Islam","role_name":"Owner","profile_pic":"https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=ZKUOvEx67DqYkrtRRq6cFqqoPmQ%3D&Expires=1633336576","phone_number":"+8801757262754","email":"info.riduan@gmail.com"},"bike":{"id":"95092052-d0de-48fe-9eda-a7f69b7f5d91","bike_short_id":"omWlZNL","qr_code":"1011020288","bike_category":"P","current_loc_coord":"23.781242,90.4211609"},"trip_duration":"2 min","reservation_duration":null,"subscription":null,"applied_promo":null,"trip_points":[{"id":"c68bc32e-9863-4e5f-b376-e84df2bdc925","title":"Completed Trip","point":1,"reduce_to_zero":false,"organization":"829a48bf-3cde-4d2f-a00a-7ee97e55c6ba"}],"rating":"--","total_cost":8.75,"invoice":{"id":"a27b6a1a-5495-45ed-b72c-7488d7a86eef","title":"Unlock, Trip","date":"2021-10-04 07:33:31","amount":8.75,"currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"settled_amount":8.75,"settled_currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"amount_is_converted":false,"discount":0.0,"is_refunded":false,"status":"C","dispute_status":"","dispute_reason":"","dispute_reference":"","is_source_refundable":false,"refund_status":"","refund_failure_reason":"","refund_reference":""},"cost":6.0,"parking_pic":null,"trip_report":{"id":"7539ef5f-f0b6-436f-a9e0-44f48538db64","report_date":"2021-10-04 07:35:07","report_categories":"Damaged Vehicle","description":"test report on vehicle","admin_remarks":null,"status":"ATTENTION_REQUIRED","vehicle_parts":["BATTERY","LIGHTS","NOISE","SLOW","THROTTLE"],"report_images":[{"id":"d6681e12-cef8-4810-a117-c13ebfd3cfb0","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/d6681e12-cef8-4810-a117-c13ebfd3cfb0_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=N0LNRi4Hk4PzA2464UxMpsBlUxc%3D&Expires=1633336576"},{"id":"935a2cb6-5f5c-4f6a-ad75-8e4afe5d0cb1","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/935a2cb6-5f5c-4f6a-ad75-8e4afe5d0cb1_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=bGEyD4gogyKKbdc0J3mVyNrncbM%3D&Expires=1633336576"},{"id":"93fc9309-ce12-4626-b5b8-bf077848391b","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/93fc9309-ce12-4626-b5b8-bf077848391b_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=%2BKFgFyN%2FcHrQmBrEIupVNXmLO%2F0%3D&Expires=1633336576"}],"created_at":"2021-10-04 07:35:07","updated_at":"2021-10-04 07:35:07"},"on_ride_trip_path":[],"currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"created_at":"2021-10-04 07:33:31","updated_at":"2021-10-04 07:36:16","trip_short_id":"VgrZDPV","src_coord":"23.7812104,90.4211778","dest_coord":"23.781242, 90.4211609","reservation_start_time":null,"reservation_end_time":null,"reason_desc":"No reason provided","reserve_task_id":null,"start_power_level":"73.000","end_power_level":"73.000","status":"C","status_forced":true,"status_forced_by_system":false,"distance":"97.000","pause_cost":"0.000","reservation_charge":"0.000","unlock_charge":"1.000","discount":"0.00","rate_per_minute":"3.00","pause_rate_per_minute":"3.00","calories":"0.00","traversed_path":[],"is_paused":false,"tax_amount":"1.75","max_billing_adjusted_amount":"0.00"}}\'',
    },
  },
  {
    id: '6daafa18-f2a1-4728-9896-1f41e83bf4b9',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_LOCK_REQUEST',
    description: "eSkoot-Test - [1011020288]'s lock request sent",
    success: true,
    parent_log_id: '2937b1d3-02ed-4f22-9eef-630af11d5971',
    location_coord: '23.781242,90.4211609',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:36:16',
    trip: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
    extra_data: {
      trip_data: {
        id: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
        status: 'O',
        discount: 0,
        net_cost: 1,
        short_id: 'VgrZDPV',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 0,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1987,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.781242,90.4211609',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: '3a6425c3-b566-4216-a779-087decb09c72',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-api.otoride.co:8083',
      path: '/dashboard/trips/717732c4-2fca-4c18-a32b-c4a2b1865cf0/complete/',
      is_secure: false,
      is_ajax: false,
      user_agent:
        'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.61 Safari/537.36',
      request_body:
        'b\'------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="trigger_lock"\\r\\n\\r\\ntrue\\r\\n------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="trigger_payment"\\r\\n\\r\\ntrue\\r\\n------WebKitFormBoundaryOmBgAR7fKW4PK5lV\\r\\nContent-Disposition: form-data; name="riding_time_min"\\r\\n\\r\\n2\\r\\n------WebKit ...',
      response_code: 200,
      response:
        'b\'{"detail":"Trip force completed","trip":{"id":"717732c4-2fca-4c18-a32b-c4a2b1865cf0","pick_up_location":"Evan & Arif, Rd No 6, Dhaka 1212, Bangladesh","drop_off_location":"Evan & Arif, Rd No 6, Dhaka 1212, Bangladesh","pick_up_time":"2021-10-04 07:33:31","drop_off_time":"2021-10-04 07:35:31","user":{"id":"cfd16c78-aefa-4715-a7cb-f3337b160f6f","full_name":"Reduanul Islam","role_name":"Owner","profile_pic":"https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=ZKUOvEx67DqYkrtRRq6cFqqoPmQ%3D&Expires=1633336576","phone_number":"+8801757262754","email":"info.riduan@gmail.com"},"bike":{"id":"95092052-d0de-48fe-9eda-a7f69b7f5d91","bike_short_id":"omWlZNL","qr_code":"1011020288","bike_category":"P","current_loc_coord":"23.781242,90.4211609"},"trip_duration":"2 min","reservation_duration":null,"subscription":null,"applied_promo":null,"trip_points":[{"id":"c68bc32e-9863-4e5f-b376-e84df2bdc925","title":"Completed Trip","point":1,"reduce_to_zero":false,"organization":"829a48bf-3cde-4d2f-a00a-7ee97e55c6ba"}],"rating":"--","total_cost":8.75,"invoice":{"id":"a27b6a1a-5495-45ed-b72c-7488d7a86eef","title":"Unlock, Trip","date":"2021-10-04 07:33:31","amount":8.75,"currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"settled_amount":8.75,"settled_currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"amount_is_converted":false,"discount":0.0,"is_refunded":false,"status":"C","dispute_status":"","dispute_reason":"","dispute_reference":"","is_source_refundable":false,"refund_status":"","refund_failure_reason":"","refund_reference":""},"cost":6.0,"parking_pic":null,"trip_report":{"id":"7539ef5f-f0b6-436f-a9e0-44f48538db64","report_date":"2021-10-04 07:35:07","report_categories":"Damaged Vehicle","description":"test report on vehicle","admin_remarks":null,"status":"ATTENTION_REQUIRED","vehicle_parts":["BATTERY","LIGHTS","NOISE","SLOW","THROTTLE"],"report_images":[{"id":"d6681e12-cef8-4810-a117-c13ebfd3cfb0","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/d6681e12-cef8-4810-a117-c13ebfd3cfb0_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=N0LNRi4Hk4PzA2464UxMpsBlUxc%3D&Expires=1633336576"},{"id":"935a2cb6-5f5c-4f6a-ad75-8e4afe5d0cb1","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/935a2cb6-5f5c-4f6a-ad75-8e4afe5d0cb1_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=bGEyD4gogyKKbdc0J3mVyNrncbM%3D&Expires=1633336576"},{"id":"93fc9309-ce12-4626-b5b8-bf077848391b","report_pic":"https://honesto-api-test.s3.amazonaws.com/bike_issue_pics/93fc9309-ce12-4626-b5b8-bf077848391b_20211004073507.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=%2BKFgFyN%2FcHrQmBrEIupVNXmLO%2F0%3D&Expires=1633336576"}],"created_at":"2021-10-04 07:35:07","updated_at":"2021-10-04 07:35:07"},"on_ride_trip_path":[],"currency":{"id":"ac6f2b83-0c35-4384-9036-187b90e361ca","name":"BDT","symbol":"\\xe0\\xa7\\xb3"},"created_at":"2021-10-04 07:33:31","updated_at":"2021-10-04 07:36:16","trip_short_id":"VgrZDPV","src_coord":"23.7812104,90.4211778","dest_coord":"23.781242, 90.4211609","reservation_start_time":null,"reservation_end_time":null,"reason_desc":"No reason provided","reserve_task_id":null,"start_power_level":"73.000","end_power_level":"73.000","status":"C","status_forced":true,"status_forced_by_system":false,"distance":"97.000","pause_cost":"0.000","reservation_charge":"0.000","unlock_charge":"1.000","discount":"0.00","rate_per_minute":"3.00","pause_rate_per_minute":"3.00","calories":"0.00","traversed_path":[],"is_paused":false,"tax_amount":"1.75","max_billing_adjusted_amount":"0.00"}}\'',
    },
  },
  {
    id: '9f834964-f8ef-477f-9db9-b80b7d9d4a4a',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_LOCK_REQUEST',
    description: "eSkoot-Test - [1011020288]'s lock request sent",
    success: true,
    parent_log_id: '2937b1d3-02ed-4f22-9eef-630af11d5971',
    location_coord: '23.7812144,90.4211594',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:35:34',
    trip: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
    extra_data: {
      trip_data: {
        id: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
        status: 'O',
        discount: 0,
        net_cost: 1,
        short_id: 'VgrZDPV',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 0,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1987,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812144,90.4211594',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: '8fe4bf94-99b8-4d3d-8ad8-3d49ad12cef3',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/717732c4-2fca-4c18-a32b-c4a2b1865cf0/scooter-lock/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body: "b'location=23.7812144%2C90.4211594'",
      response_code: 200,
      response:
        'b\'{"status":"Success","msg":"Your scooter will lock in a moment!"}\'',
    },
  },
  {
    id: '9d0e419b-c9d4-4fea-a682-7457602e4540',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_CABLE_UNLOCKED',
    description: 'eSkoot-Test - [1011020288] cable unlocked successfully',
    success: true,
    parent_log_id: '2937b1d3-02ed-4f22-9eef-630af11d5971',
    location_coord: '23.7812104,90.4211778',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:33:33',
    trip: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
    extra_data: {
      trip_data: {
        id: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
        status: 'O',
        discount: 0,
        net_cost: 1,
        short_id: 'VgrZDPV',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 0,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1987,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812104,90.4211778',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: 'df8e04a9-35bc-4af8-8ae1-d732701dde0c',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_UNLOCKED',
    description: 'eSkoot-Test - [1011020288] was unlocked',
    success: true,
    parent_log_id: '2937b1d3-02ed-4f22-9eef-630af11d5971',
    location_coord: '23.7812104,90.4211778',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:33:32',
    trip: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
    extra_data: {
      trip_data: {
        id: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
        status: 'O',
        discount: 0,
        net_cost: 1,
        short_id: 'VgrZDPV',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 0,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1987,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812104,90.4211778',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: '2937b1d3-02ed-4f22-9eef-630af11d5971',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_TRIP_STARTED',
    description: 'SCOOTER eSkoot-Test - [1011020288] started trip',
    success: true,
    parent_log_id: '2937b1d3-02ed-4f22-9eef-630af11d5971',
    location_coord: '23.7812104,90.4211778',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:33:31',
    trip: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
    extra_data: {
      trip_data: {
        id: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
        status: 'U',
        discount: 0,
        net_cost: 1,
        short_id: 'VgrZDPV',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 0,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1987,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812104,90.4211778',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: 'a7f7bf20-4a0d-43d1-8d50-0b4c386b2c8f',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/bike/unlock/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body:
        "b'bike_id=1011020288&location=23.781213777869027%2C90.42116498574615&bluetooth_enabled=false'",
      response_code: 200,
      response:
        'b\'{"status":"Success","msg":"SCOOTER will unlock in a moment!","trip_id":"717732c4-2fca-4c18-a32b-c4a2b1865cf0"}\'',
    },
  },
  {
    id: 'c72525c1-6071-4f5e-940c-46634fcaac17',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_UNLOCK_REQUEST',
    description:
      'Reduanul Islam sent unlock request (Unlock Charge \u09f31.00)',
    success: true,
    parent_log_id: '0678475e-8637-4ed8-8c78-39462ecb3eb4',
    location_coord: '23.7812104,90.4211778',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:33:31',
    trip: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
    extra_data: {
      trip_data: {
        id: '717732c4-2fca-4c18-a32b-c4a2b1865cf0',
        status: 'U',
        discount: 0,
        net_cost: 1,
        short_id: 'VgrZDPV',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 0,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1987,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'L',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812104,90.4211778',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: 'a7f7bf20-4a0d-43d1-8d50-0b4c386b2c8f',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/bike/unlock/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body:
        "b'bike_id=1011020288&location=23.781213777869027%2C90.42116498574615&bluetooth_enabled=false'",
      response_code: 200,
      response:
        'b\'{"status":"Success","msg":"SCOOTER will unlock in a moment!","trip_id":"717732c4-2fca-4c18-a32b-c4a2b1865cf0"}\'',
    },
  },
  {
    id: 'daf36c22-fe95-4cb7-9b5b-d59f53f40a24',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: '33b97efe-e8ab-455f-b795-b61be4010aad',
      full_name: 'Roman Ma\u0161ata',
      role_name: '--',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/infoignit-ride.com_20210930165436.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=7AqMx3BEXvgYBuf79ZkSt5b6%2Fck%3D&Expires=1633420847',
    },
    action_type: 'BIKE_GOOD_FEEDBACK',
    description: 'Rider Roman Ma\u0161ata gave GOOD feedback.',
    success: true,
    parent_log_id: null,
    location_coord: null,
    vehicle_power_level: 0,
    created_at: '2021-10-04 07:21:53',
    trip: 'd8fbab47-1533-4acc-9453-20e72148da3f',
    extra_data: {},
    invocation_scope: 'oto.apps.trip.views',
    request_trace: null,
  },
  {
    id: '806c01ce-3ed8-478a-978a-e9b608ae41e8',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_GOOD_FEEDBACK',
    description: 'Rider Reduanul Islam gave GOOD feedback.',
    success: true,
    parent_log_id: 'ef402651-bae1-4739-82f8-122c027efd77',
    location_coord: '23.7812104,90.4211778',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:14:56',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'C',
        discount: 0,
        net_cost: 6,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: '59 s',
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: '1 min',
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1987,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'N',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: { rating: 5 },
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'L',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812104,90.4211778',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.views',
    request_trace: {
      id: '2449a6e4-8298-4d9d-a780-d25dade809d5',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/bac7413d-93fd-459e-b85a-f62e60bdf7fb/feedback/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body: "b'rating=5'",
      response_code: 200,
      response: 'b\'{"status":"Success","msg":"Thank you for rating!"}\'',
    },
  },
  {
    id: 'ef402651-bae1-4739-82f8-122c027efd77',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_TRIP_COMPLETED',
    description:
      "eSkoot-Test - [1011020288]'s trip [mWljAZY] is completed | (Total Cost \u09f36.19)",
    success: true,
    parent_log_id: 'ef402651-bae1-4739-82f8-122c027efd77',
    location_coord: '23.7812104,90.4211778',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:13:51',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'C',
        discount: 0,
        net_cost: 6,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: '59 s',
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: '1 min',
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1987,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'F',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'L',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812104,90.4211778',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: 'f2d9a3b0-172f-428f-a9fe-e131d5e3a327',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/bac7413d-93fd-459e-b85a-f62e60bdf7fb/complete/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body:
        'b\'--41e0303d-cae5-457f-a5c7-7883ee5b5942\\r\\ncontent-disposition: form-data; name="location"\\r\\nContent-Length: 21\\r\\n\\r\\n23.7812097,90.4211729\\r\\n--41e0303d-cae5-457f-a5c7-7883ee5b5942--\\r\\n\'',
      response_code: 200,
      response:
        'b\'{"status":"Success","trip_status":"C","trip_detail":{"bike_id":"95092052-d0de-48fe-9eda-a7f69b7f5d91","rate_per_minute":3.0,"total_distance":3645,"total_cost":2.95,"discount":0.0,"tax_amount":1.2375,"net_cost":6.1875,"reservation_charge":1.0,"unlock_charge":1.0,"calories":0.0,"start_time":"2021-10-04T07:12:52.130901Z","end_time":"2021-10-04T07:13:51.143223Z","riding_time":59,"trip_status":"C","source_coord":"23.7748901356519,90.41288720614453","destination_coord":"23.7812104, 90.4211778","max_billing_adjusted_amount":0.0,"applied_promo":null,"applied_pass":null,"is_promo_code_applied":false,"is_pass_applied":false,"is_max_billing_adjusted":false,"discount_reasons":[],"duration":59,"packages":[]}}\'',
    },
  },
  {
    id: '9d18bb72-28f1-457d-b32d-1830b191d0a1',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_LOCKED',
    description: 'eSkoot-Test - [1011020288] locked successfully',
    success: true,
    parent_log_id: '54b970b3-6f8a-4c26-b809-9976aea27e31',
    location_coord: '23.7812104,90.4211778',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:13:42',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'O',
        discount: 0,
        net_cost: 2,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: '1 min',
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1994,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812104,90.4211778',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: '4f351a9e-407c-451a-a196-d3fa31318782',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_LOCK_REQUEST',
    description: "eSkoot-Test - [1011020288]'s lock request sent",
    success: true,
    parent_log_id: '54b970b3-6f8a-4c26-b809-9976aea27e31',
    location_coord: '23.7812104,90.4211778',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:13:41',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'O',
        discount: 0,
        net_cost: 2,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: '1 min',
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1994,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7812104,90.4211778',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: 'e979f8c3-7d04-4b98-86f8-ec4f6e4de750',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/bac7413d-93fd-459e-b85a-f62e60bdf7fb/scooter-lock/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body: "b'location=23.7812104%2C90.4211778'",
      response_code: 200,
      response:
        'b\'{"status":"Success","msg":"Your scooter will lock in a moment!"}\'',
    },
  },
  {
    id: '6718353a-3403-43de-938b-3b18e9c3676e',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_CABLE_UNLOCKED',
    description: 'eSkoot-Test - [1011020288] cable unlocked successfully',
    success: true,
    parent_log_id: '54b970b3-6f8a-4c26-b809-9976aea27e31',
    location_coord: '23.7748901356519,90.41288720614453',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:12:54',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'O',
        discount: 0,
        net_cost: 2,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: '1 min',
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1994,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 21,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7748901356519,90.41288720614453',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: 'ffff7bad-a692-40d0-aed6-1ac8ed7cd4f1',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_UNLOCKED',
    description: 'eSkoot-Test - [1011020288] was unlocked',
    success: true,
    parent_log_id: '54b970b3-6f8a-4c26-b809-9976aea27e31',
    location_coord: '23.7748901356519,90.41288720614453',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:12:53',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'O',
        discount: 0,
        net_cost: 2,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: '1 min',
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1994,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 21,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7748901356519,90.41288720614453',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: '2481c7ef-0c47-4aab-8b7c-d072fd638283',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_TRIP_STARTED',
    description: 'SCOOTER eSkoot-Test - [1011020288] started trip',
    success: true,
    parent_log_id: '54b970b3-6f8a-4c26-b809-9976aea27e31',
    location_coord: '23.7748901356519,90.41288720614453',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:12:52',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'U',
        discount: 0,
        net_cost: 2,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: '1 min',
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1994,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 21,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7748901356519,90.41288720614453',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: 'f35cba00-c2f1-4dcf-8c75-650423ecc267',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/bike/unlock/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body:
        "b'bike_id=1011020288&location=23.7812383%2C90.4211639&bluetooth_enabled=false'",
      response_code: 200,
      response:
        'b\'{"status":"Success","msg":"SCOOTER will unlock in a moment!","trip_id":"bac7413d-93fd-459e-b85a-f62e60bdf7fb"}\'',
    },
  },
  {
    id: '6ccff2cf-f877-48d1-8415-c19fc868bf7a',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_UNLOCK_REQUEST',
    description:
      'Reduanul Islam sent unlock request (Unlock Charge \u09f31.00)',
    success: true,
    parent_log_id: '54b970b3-6f8a-4c26-b809-9976aea27e31',
    location_coord: '23.7748901356519,90.41288720614453',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:12:52',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'U',
        discount: 0,
        net_cost: 2,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 1,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: '1 min',
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1994,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'T',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 21,
        },
        is_on_ride: true,
        trip_status: 'U',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7748901356519,90.41288720614453',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: 'f35cba00-c2f1-4dcf-8c75-650423ecc267',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/bike/unlock/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body:
        "b'bike_id=1011020288&location=23.7812383%2C90.4211639&bluetooth_enabled=false'",
      response_code: 200,
      response:
        'b\'{"status":"Success","msg":"SCOOTER will unlock in a moment!","trip_id":"bac7413d-93fd-459e-b85a-f62e60bdf7fb"}\'',
    },
  },
  {
    id: 'c839bc27-cfc9-4d87-bce9-37414d9b5452',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
      full_name: 'Reduanul Islam',
      role_name: 'Owner',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/info.riduangmail.com_20210104122834.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=Gj%2FPxFOccaj1GuRyOwOWTQyOUa8%3D&Expires=1633420847',
    },
    action_type: 'BIKE_RESERVED',
    description:
      'eSkoot-Test - [1011020288] is reserved by Reduanul Islam (Reservation Charge \u09f31.00)',
    success: true,
    parent_log_id: '9dadb559-3d45-45a3-8047-471e5ee73d52',
    location_coord: '23.7748901356519,90.41288720614453',
    vehicle_power_level: '73.00',
    created_at: '2021-10-04 07:11:01',
    trip: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
    extra_data: {
      trip_data: {
        id: 'bac7413d-93fd-459e-b85a-f62e60bdf7fb',
        status: 'R',
        discount: 0,
        net_cost: 1,
        short_id: 'mWljAZY',
        pass_data: null,
        promo_data: null,
        has_invoice: true,
        status_forced: false,
        trip_duration: null,
        unlock_charge: 0,
        cancel_reason_desc: 'No reason provided',
        reservation_charge: 1,
        reservation_duration: null,
        status_forced_by_system: false,
      },
      user_data: {
        id: 'cfd16c78-aefa-4715-a7cb-f3337b160f6f',
        role: 'Owner',
        profile_data: {
          email: 'info.riduan@gmail.com',
          balance: 1994,
          full_name: 'Reduanul Islam',
          app_version: null,
          trip_status: 'R',
          user_status: 'A',
          phone_number: '+8801757262754',
          current_fleet: {
            id: '5b154e50-5e5f-42df-b433-379072f324b0',
            name: 'OTORide-HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: true,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 73,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 21,
        },
        is_on_ride: false,
        trip_status: 'R',
        is_available: true,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.7748901356519,90.41288720614453',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.services',
    request_trace: {
      id: '47dc566a-95d4-410c-9603-c89c5923f991',
      ip_address: '119.30.47.24',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path: '/api/v1/trip/reserve_bike/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'okhttp/3.12.12',
      request_body:
        "b'bike_id=95092052-d0de-48fe-9eda-a7f69b7f5d91&location=23.7748901356519%2C90.41288720614453'",
      response_code: 200,
      response:
        'b\'{"status":"Success","msg":"Reservation successful!","trip_id":"bac7413d-93fd-459e-b85a-f62e60bdf7fb"}\'',
    },
  },
  {
    id: 'ae1f84c4-7ab0-4d76-ac1f-bbe32014483f',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: '33b97efe-e8ab-455f-b795-b61be4010aad',
      full_name: 'Roman Ma\u0161ata',
      role_name: '--',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/infoignit-ride.com_20210930165436.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=7AqMx3BEXvgYBuf79ZkSt5b6%2Fck%3D&Expires=1633420847',
    },
    action_type: 'BIKE_TRIP_COMPLETED',
    description:
      "eSkoot-Test - [1011020288]'s trip [NQ66pJr] is completed | (Total Cost \u09f32.56)",
    success: true,
    parent_log_id: null,
    location_coord: null,
    vehicle_power_level: 0,
    created_at: '2021-10-04 07:06:30',
    trip: 'd8fbab47-1533-4acc-9453-20e72148da3f',
    extra_data: {},
    invocation_scope: 'oto.apps.trip.services',
    request_trace: null,
  },
  {
    id: 'b43fc62f-caa3-4351-b806-1d6c40a13b8c',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: '33b97efe-e8ab-455f-b795-b61be4010aad',
      full_name: 'Roman Ma\u0161ata',
      role_name: '--',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/infoignit-ride.com_20210930165436.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=7AqMx3BEXvgYBuf79ZkSt5b6%2Fck%3D&Expires=1633420847',
    },
    action_type: 'BIKE_LOCKED',
    description: 'eSkoot-Test - [1011020288] locked successfully',
    success: true,
    parent_log_id: null,
    location_coord: null,
    vehicle_power_level: 0,
    created_at: '2021-10-04 07:06:21',
    trip: 'd8fbab47-1533-4acc-9453-20e72148da3f',
    extra_data: {},
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: '22520645-dc97-4f07-b8ff-d99a42d40f23',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: '33b97efe-e8ab-455f-b795-b61be4010aad',
      full_name: 'Roman Ma\u0161ata',
      role_name: '--',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/infoignit-ride.com_20210930165436.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=7AqMx3BEXvgYBuf79ZkSt5b6%2Fck%3D&Expires=1633420847',
    },
    action_type: 'BIKE_LOCK_REQUEST',
    description: "eSkoot-Test - [1011020288]'s lock request sent",
    success: true,
    parent_log_id: null,
    location_coord: null,
    vehicle_power_level: 0,
    created_at: '2021-10-04 07:06:20',
    trip: 'd8fbab47-1533-4acc-9453-20e72148da3f',
    extra_data: {},
    invocation_scope: 'oto.apps.trip.services',
    request_trace: null,
  },
  {
    id: '7bcb60b1-8325-4b2f-835b-a30a9a7092a3',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: '33b97efe-e8ab-455f-b795-b61be4010aad',
      full_name: 'Roman Ma\u0161ata',
      role_name: '--',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/infoignit-ride.com_20210930165436.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=xDfw1Uw9en3nUMjxyZAUrdJOqek%3D&Expires=1633420848',
    },
    action_type: 'BIKE_CABLE_UNLOCKED',
    description: 'eSkoot-Test - [1011020288] cable unlocked successfully',
    success: true,
    parent_log_id: null,
    location_coord: null,
    vehicle_power_level: 0,
    created_at: '2021-10-04 07:06:09',
    trip: 'd8fbab47-1533-4acc-9453-20e72148da3f',
    extra_data: {},
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: 'a38aa368-2a93-4b1a-a5d6-6636466a30df',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: '33b97efe-e8ab-455f-b795-b61be4010aad',
      full_name: 'Roman Ma\u0161ata',
      role_name: '--',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/infoignit-ride.com_20210930165436.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=xDfw1Uw9en3nUMjxyZAUrdJOqek%3D&Expires=1633420848',
    },
    action_type: 'BIKE_UNLOCKED',
    description: 'eSkoot-Test - [1011020288] was unlocked',
    success: true,
    parent_log_id: null,
    location_coord: null,
    vehicle_power_level: 0,
    created_at: '2021-10-04 07:06:08',
    trip: 'd8fbab47-1533-4acc-9453-20e72148da3f',
    extra_data: {},
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: '7eccd390-1d08-4ac4-9468-a468fc6dce87',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: '33b97efe-e8ab-455f-b795-b61be4010aad',
      full_name: 'Roman Ma\u0161ata',
      role_name: '--',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/infoignit-ride.com_20210930165436.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=xDfw1Uw9en3nUMjxyZAUrdJOqek%3D&Expires=1633420848',
    },
    action_type: 'BIKE_TRIP_STARTED',
    description: 'SCOOTER eSkoot-Test - [1011020288] started trip',
    success: true,
    parent_log_id: null,
    location_coord: null,
    vehicle_power_level: 0,
    created_at: '2021-10-04 07:06:08',
    trip: 'd8fbab47-1533-4acc-9453-20e72148da3f',
    extra_data: {},
    invocation_scope: 'oto.apps.trip.services',
    request_trace: null,
  },
  {
    id: '9a5d34be-2d22-40f9-a3bc-5679be1d28c0',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: '33b97efe-e8ab-455f-b795-b61be4010aad',
      full_name: 'Roman Ma\u0161ata',
      role_name: '--',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/infoignit-ride.com_20210930165436.jpg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=xDfw1Uw9en3nUMjxyZAUrdJOqek%3D&Expires=1633420848',
    },
    action_type: 'BIKE_UNLOCK_REQUEST',
    description:
      'Roman Ma\u0161ata sent unlock request (Unlock Charge \u09f31.00)',
    success: true,
    parent_log_id: null,
    location_coord: null,
    vehicle_power_level: 0,
    created_at: '2021-10-04 07:06:07',
    trip: 'd8fbab47-1533-4acc-9453-20e72148da3f',
    extra_data: {},
    invocation_scope: 'oto.apps.trip.services',
    request_trace: null,
  },
  {
    id: '86159b89-0a04-442f-9d0f-e900a4b442fe',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: null,
    action_type: 'BIKE_ILLEGALLY_MOVED',
    description: 'eSkoot-Test - [1011020288] moved illegally',
    success: true,
    parent_log_id: null,
    location_coord: '23.774925,90.41287551390288',
    vehicle_power_level: '75.00',
    created_at: '2021-10-04 06:14:02',
    trip: null,
    extra_data: {
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: true,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 75,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 15,
        },
        is_on_ride: false,
        trip_status: 'L',
        is_available: false,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.774925,90.41287551390288',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: 'e048ea5c-497e-4a02-86f5-4e2d22f2f370',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: {
      id: 'ef179d22-435b-46e2-99f0-7343ff6cc2bc',
      full_name: 'Pappu Pappu',
      role_name: 'Operator',
      profile_pic:
        'https://honesto-api-test.s3.amazonaws.com/profile_pics/pappu.paul10000gmail.com_20210911062419.jpeg?AWSAccessKeyId=AKIAJIFJVGLKPDEBTBVQ&Signature=RnNdlUdW1tBJ2sAP6vlCzGU8qKo%3D&Expires=1633420848',
    },
    action_type: 'BIKE_RING_ALARM',
    description: 'Vehicle is ringed by Pappu Pappu...',
    success: true,
    parent_log_id: null,
    location_coord: '23.774925,90.41287551390288',
    vehicle_power_level: '75.00',
    created_at: '2021-10-03 18:50:47',
    trip: null,
    extra_data: {
      user_data: {
        id: 'ef179d22-435b-46e2-99f0-7343ff6cc2bc',
        role: 'Operator',
        profile_data: {
          email: 'pappu.paul10000@gmail.com',
          balance: 0,
          full_name: 'Pappu Pappu',
          app_version: null,
          trip_status: 'N',
          user_status: 'A',
          phone_number: '+8801843668853',
          current_fleet: {
            id: '860a2937-5d6d-471f-8b28-fd32683467d7',
            name: 'Croatia - IGNIT-  HQ',
          },
          app_device_model: null,
          last_stored_ip_addrs: 'None',
        },
      },
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: true,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 75,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'L',
        is_available: false,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.774925,90.41287551390288',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.operation.views',
    request_trace: {
      id: 'b50e9d64-293e-4a99-8067-2f39d4d79c23',
      ip_address: '103.85.114.65',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path:
        '/api/v1/operation/vehicles/95092052-d0de-48fe-9eda-a7f69b7f5d91/alarm/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'Dart/2.14 (dart:io)',
      request_body:
        "b'--dart-http-boundary-taOJLPPYG4uS7dL.FN_md_M5YwEk-3XasS9kofzgNILI9qnrV3C--\\r\\n'",
      response_code: 200,
      response: 'b\'{"details":"Vehicle is ringed"}\'',
    },
  },
  {
    id: '30a83123-eff6-4311-8429-544c72200c1f',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: null,
    action_type: 'BIKE_LOCKED',
    description: 'eSkoot-Test - [1011020288] locked successfully',
    success: true,
    parent_log_id: null,
    location_coord: '23.774925,90.41287551390288',
    vehicle_power_level: '75.00',
    created_at: '2021-10-03 17:10:33',
    trip: null,
    extra_data: {
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: true,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: true,
          power_level: 75,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'U',
        is_available: false,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.774925,90.41287551390288',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.trip.tasks',
    request_trace: null,
  },
  {
    id: '042d2b7e-8d42-453f-bd81-b3e05093b482',
    actor: {
      id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
      bike_short_id: 'omWlZNL',
      qr_code: '1011020288',
      bike_category: 'P',
      current_loc_coord: '23.774837691838016,90.41275793356924',
    },
    target: null,
    action_type: 'BIKE_FORCE_LOCK_REQUEST',
    description: 'Bike force lock request sent by Pappu Pappu',
    success: true,
    parent_log_id: null,
    location_coord: '23.774925,90.41287551390288',
    vehicle_power_level: '75.00',
    created_at: '2021-10-03 17:10:32',
    trip: null,
    extra_data: {
      context_data: null,
      vehicle_data: {
        id: '95092052-d0de-48fe-9eda-a7f69b7f5d91',
        fleet: {
          id: '5b154e50-5e5f-42df-b433-379072f324b0',
          name: 'OTORide-HQ',
        },
        qr_code: '1011020288',
        is_parked: false,
        lock_data: {
          qr_code: '862506041134928',
          is_locked: false,
          power_level: 75,
          iot_category: 'OMNI_SCOOTER',
          is_operational: true,
          network_signal: 18,
        },
        is_on_ride: false,
        trip_status: 'U',
        is_available: false,
        service_area: {
          id: '03398595-933b-44e4-8931-80de689f83d6',
          name: 'Niketan-HQ',
        },
        current_location: '23.774925,90.41287551390288',
        position_accuracy: 500,
      },
    },
    invocation_scope: 'oto.apps.operation.views',
    request_trace: {
      id: '60340816-2ef7-4e0f-9212-4e0a50082f3a',
      ip_address: '103.85.114.65',
      method: 'POST',
      host: 'dev-oto-api.otoride.co',
      path:
        '/api/v1/operation/vehicles/95092052-d0de-48fe-9eda-a7f69b7f5d91/lock/',
      is_secure: false,
      is_ajax: false,
      user_agent: 'Dart/2.14 (dart:io)',
      request_body:
        "b'--dart-http-boundary-Ubk9uCmgBIW2+8JG4n3gtqVJvoAUgTi8aMWiK_f7ZeM1Z_Vs+Kj--\\r\\n'",
      response_code: 200,
      response: 'b\'{"detail":"Attempting to lock vehicle"}\'',
    },
  },
]

// parents parent_log_id === null || id === parent_log_id
const parents = logs.filter(
  (log) => log.id === log.parent_log_id || log.parent_log_id === null
)

// exclude parents array form logs array
const children = logs.filter(
  (log) => log.parent_log_id !== null && log.parent_log_id !== log.id
)

// children.forEach((c) => console.log(`cid: ${c.id} `))

// merge children with parents
const merged = parents.map((parent) => {
  const child = children.filter((child) => child.parent_log_id === parent.id)
  return {
    ...parent,
    children: child,
  }
})

console.log(
  'counts (t p c m)',
  logs.length,
  parents.length,
  children.length,
  merged.length
)
merged.forEach((m) => console.log('m:' + m.children.length + '\n'))
// sort by created_at, latest first
merged.sort((a, b) => {
  return new Date(b.created_at) - new Date(a.created_at)
  // return new Date(a.created_at) - new Date(b.created_at)
})

import { groupBy } from 'lodash-es'
// chunk the array by dates (group by date)
const chunks = groupBy(merged, (m) => {
  return new Date(m.created_at).toDateString()
})

console.log('chunks', chunks.length)

// console.log(JSON.stringify(merged, null, 2))
export default chunks

export const positiveActions = {
  BIKE_RESERVED: 'Requested for reservation',
  BIKE_RESERVATION_CANCELLED: 'Reservation cancelled',
  BIKE_TRIP_STARTED: 'Trip started',
  BIKE_TRIP_COMPLETED: 'Trip Completed',
  BIKE_TRIP_CANCELLED: 'Force Trip Cancelled',
  BIKE_UNLOCK_REQUEST: 'Unlock Request Sent',
  BIKE_CABLE_UNLOCK_REQUEST: 'Scooter Cable unlock request sent',
  BIKE_UNLOCKED: 'Vehicle Unlocked',
  BIKE_CABLE_UNLOCKED: 'Scooter Cable unlocked',
  BIKE_LOCK_REQUEST: 'Requested for locking vehicle',
  BIKE_CABLE_LOCK_REQUEST: 'Scooter Cable lock request sent',
  BIKE_LOCKED: 'Vehicle Locked',
  BIKE_CABLE_LOCKED: 'Scooter Cable locked',
  BIKE_GOOD_FEEDBACK: 'Rider Gave ‘Good’ Feedback',
  BIKE_BAD_FEEDBACK: 'Rider Gave ‘Bad’ Feedback',
  BIKE_FORCE_LOCK_REQUEST: 'Force Lock Request',
  BIKE_FORCE_UNLOCK_REQUEST: 'Force Unlock Request',
  BIKE_FORCE_TRIP_COMPLETED: 'Force Trip Completed',
}
export const negativeActions = {
  BIKE_RESERVED: 'Requested for reservation failed',
  BIKE_RESERVATION_CANCELLED: 'Reservation cancelletion failed',
  BIKE_TRIP_STARTED: 'Trip Start Failed',
  BIKE_TRIP_COMPLETED: 'Trip Complete Failed',
  BIKE_TRIP_CANCELLED: 'Force Trip Cancel Failed',
  BIKE_UNLOCK_REQUEST: 'Unlock Request Failed',
  BIKE_CABLE_UNLOCK_REQUEST: 'Scooter Cable unlock request failed',
  BIKE_UNLOCKED: 'Vehicle failed to Unlock',
  BIKE_CABLE_UNLOCKED: 'Scooter Cable unlocking failed',
  BIKE_LOCK_REQUEST: 'Lock Request Failed',
  BIKE_CABLE_LOCK_REQUEST: 'Scooter Cable lock request failed',
  BIKE_LOCKED: 'Vehicle failed to Lock',
  BIKE_CABLE_LOCKED: 'Scooter Cable lock failed',
  BIKE_GOOD_FEEDBACK: 'Error while giving feedback',
  BIKE_BAD_FEEDBACK: 'Error while giving feedback',
  BIKE_FORCE_LOCK_REQUEST: 'Force Lock Request Failed',
  BIKE_FORCE_UNLOCK_REQUEST: 'Force Unlock Request Failed',
  BIKE_FORCE_TRIP_COMPLETED: 'Force Trip Complete Failed',
}
